import { makeRequest } from 'utils/requestLogger';
import store from 'store';

export default (course) =>
  makeRequest('post', '/api/courses', course).then((res) => {
    store.dispatch(
      'analytics',
      'create course - service is called and returned'
    );
    return res.data;
  });



// WEBPACK FOOTER //
// ./src/app/services/courses/createCourse.js